import { inject, provideEnvironmentInitializer } from '@angular/core';
import { InitService } from '@infodata-group/inf-commons';
import { DeviceDetectorService } from '@monorepo-projects/inf-commons-lib';
import { environment } from '../../environments/environment';
import { DEFAULT_AUTH_ROUTES } from '@infodata-group/inf-commons-mobile';

const appInitFactory = () => {
  const initService = inject(InitService);
  const deviceService = inject(DeviceDetectorService);
  initService.init(environment.env);
  if (!deviceService.isDesktopDevice()) {
    const currentUrl = window.location.href;
    if (currentUrl.includes(DEFAULT_AUTH_ROUTES[2].path)) {
      const splitUrl = currentUrl.split(DEFAULT_AUTH_ROUTES[2].path);
      window.location.href =
        environment.mobileUrl + DEFAULT_AUTH_ROUTES[2].path + splitUrl[1];
    } else {
      window.location.href = environment.mobileUrl;
    }
  }
};

export const initProvider = provideEnvironmentInitializer(appInitFactory);
